import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface GoldPricePayload {
  karat: number;
  pricePerGram: number;
}

export interface SilverPricePayload {
  pricePerGram: number;
}


@Injectable({
  providedIn: 'root'
})
export class PriceService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Update gold price
  updateGoldPrice(price: GoldPricePayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/prices/gold`,  price );
  }

  // Update silver price
  updateSilverPrice(price: SilverPricePayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/prices/silver`, price );
  }

  // Get current prices
  getGoldPrices(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/gold/current/22`);
  }

   getSilverPrices(): Observable<any> {
    return this.http.get(`${this.baseUrl}/prices/silver/current`);
  }
}
